import { render, staticRenderFns } from "./upcoming-recipients-table.vue?vue&type=template&id=4a6f29aa"
import script from "./upcoming-recipients-table.vue?vue&type=script&lang=js"
export * from "./upcoming-recipients-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports